import { render, staticRenderFns } from "./BucketTitleList.vue?vue&type=template&id=650f16de&scoped=true&"
import script from "./BucketTitleList.vue?vue&type=script&lang=js&"
export * from "./BucketTitleList.vue?vue&type=script&lang=js&"
import style0 from "./BucketTitleList.vue?vue&type=style&index=0&id=650f16de&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650f16de",
  null
  
)

export default component.exports